import React from "react";

const StaircasesInaccessibilityAtThePalaceOutline = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="751.508"
      height="549.653"
      fillRule="nonzero"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      clipRule="evenodd"
      version="1.1"
      viewBox="0 0 751.508 549.653"
      xmlSpace="preserve"
      className="clickable"
    >
      <clipPath id="ArtboardFrame">
        <path d="M0 0H2800V2160H0z"></path>
      </clipPath>
      <g
        clipPath="url(#ArtboardFrame)"
        transform="translate(-747.72 -1610.347)"
      >
        <path
          className="object-glow"
          fill="rgba(0,0,0,0)"
          stroke="#ff5c97"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="5"
          d="M1456.87 1645.08s-8.7-.72-11.68 1.73c-2.98 2.44-1.39 8.62-1.39 8.62s-13.37.57-14.94 1.11c-5.69 1.94-4.61 15.15-4.61 15.15s-18.23.64-20.41 2.66c-2.04 1.89-4.33 16.32-4.33 16.32s-31.74.72-37.66 2.42c-5.44 1.55-10.69 20.53-10.69 20.53s-21.08-.24-23.56 1.06c-5.78 3.03-11.58 23.18-11.58 23.18s-28.87-1.47-32.37-.57c-2.81.72-5.28 21.12-5.28 21.12s-27.67.18-30.59 1.72c-5.39 2.83-1.9 30.98-1.9 30.98s-45.78-.48-49.28 2.05c-4.02 2.9-9.86 36.8-9.86 36.8s-40.83-.41-45.92 3c-6.91 4.62-5.21 41.53-5.21 41.53s-64.83-1.19-68.42 2.99c-6.64 7.71-22.48 69.31-22.48 69.31s-45.707.32-50.294 5.31c-6.059 6.59-2.391 48.51-2.391 48.51s-44.703-1.34-70.002.93c-25.904 2.32-34.706 14.3-40.825 22.4-12.138 16.08-10.519 14.21-26.24 30.32-15.721 16.11-36.646 34.12-36.646 34.12s-31.819-9.7-33.211-1.29c-3.071 18.57-1.371 72.65-1.371 72.65"
          opacity="1"
        ></path>
      </g>
    </svg>
  );
}

export default StaircasesInaccessibilityAtThePalaceOutline;
